import React from 'react'

export default function HeadingStyle({ children }) {
  return <div style={{ fontSize: '2em', fontWeight: 'bold' }}>{children}</div>
}
